<template>
    <div class="position-absolute upper-right">

        <a v-if="pdfExportAvailable" :href="pdfLink" target="_blank">
            <div class="circle-icon-container d-flex justify-content-center align-items-center rounded-circle bg-light mx-1">
                <i class="fal fa-file-pdf text-primary"></i>
            </div>
        </a>

        <router-link v-if="includeOpen" :to="detailsRoute" class="no-underline">
            <div class="circle-icon-container d-flex justify-content-center align-items-center rounded-circle bg-light mx-1">
                <i class="fas fa-folder-open text-primary"></i>
            </div>
        </router-link>

        <router-link :to="editRoute" class="no-underline">
            <div class="circle-icon-container d-flex justify-content-center align-items-center rounded-circle bg-light mx-1">
                <i class="fas fa-pencil text-primary"></i>
            </div>
        </router-link>

        <a href="javascript:void(0)" @click="onDeleteClick(document)">
            <div class="circle-icon-container d-flex justify-content-center align-items-center rounded-circle bg-light mx-1">
                <i class="fas fa-trash text-primary"></i>
            </div>
        </a>

    </div>
</template>

<script>
    export default {
        name: 'ListItemActions',
        props: ['table', 'document', 'parentDocument', 'parentTable', 'includeOpen'],
        data() {
            return {
                model: webase.model
            }
        },
        computed: {
            documentId() {
                return this.document['id']
            },
            editRoute(documentId) {
                return {name: 'edit-object', params: {table_id: this.table.id, document_id: this.documentId}}
            },
            detailsRoute() {
                if(webase.utils.table.hasDetailsView(this.table)) {
                    let detailsView = webase.utils.table.getDetailsView(this.table)
                    return {name: 'details-view', params: {view_id: detailsView.id, record_id: this.documentId}}
                }

                return {name: 'static-details', params: {table_id: this.table.id, record_id: this.documentId}}
            },
            parentDocumentId() {
                return this.parentDocument && this.parentDocument['id'] ? this.parentDocument['id'] : null
            },
            parentTableId() {
                return this.parentTable && this.parentTable.id ? this.parentTable.id : null
            },
            pdfExportAvailable() {
                if (this.parentTable && webase.utils.table.supportsPdf(this.parentTable)) {
                    return true
                }

                if (this.hasRelatedTable) {
                    let relatedTable = webase.managers.app.getTable(this.relatedTableId)
                    return webase.utils.table.supportsPdf(relatedTable)
                }

                return false
            },
            hasParentData() {
                return this.parentDocumentId !== null && this.parentTableId !== null
            },
            pdfLink() {

                if (this.hasParentData) {
                    return '/pdf/' + this.parentTableId + '/' + this.parentDocumentId +
                        '/' + this.table.id + '/' + this.document['id']
                }

                if (this.hasRelatedTable && this.hasRelatedDocument) {
                    return '/pdf/' + this.relatedTable.id + '/' + this.relatedDocumentId +
                        '/' + this.table.id + '/' + this.document['id']
                }

                return '#'
            },
            hasRelatedTable() {
                return this.linkedObjectField !== null
            },
            linkedObjectField() {
                return webase.utils.table.getLinkedObjectField(this.table)
            },
            relatedTableId() {
                return this.linkedObjectField.related_model_id
            },
            relatedTable() {
                return webase.managers.app.getTable(this.relatedTableId)
            },
            hasRelatedDocument() {
                let relatedObject = this.fieldValue(this.linkedObjectField)

                if (relatedObject) {
                    return Object.keys(relatedObject).length > 0
                }

                return false
            },
            relatedDocumentId() {
                let relatedObject = this.fieldValue(this.linkedObjectField)
                let documentIds = Object.keys(relatedObject)
                return documentIds.length > 0 ? documentIds[0] : null
            }
        },
        methods: {
            onDeleteClick(document) {
                this.$emit('documentDeleteClick', document)
            }
        }
    }
</script>

<style>

</style>
